//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { queryAllList } from '../../assets/js/sql'
import { pageCreate } from "@/api/create";
export default {
  name: "mychat",
  data: function() {
    return {
      title: "我的创作",
      active: 0,
      activeIndex: 0,
      showNameModal: false,
      actions: [{ name: '会话名称' }, { name: '删除会话' }],
      oprationModal: false,
      dataList: [
        {
          title: '123',
          answer: '爱上你飞蛾物管部以和为贵腐恶爱上你飞蛾物管部以和为贵腐恶爱上你飞蛾物管部以和为贵腐恶爱上你飞蛾物管部以和为贵腐恶爱上你飞蛾物管部以和为贵腐恶'
        }
      ],
      createList: []
      // dataList: [
      //   {
      //     type: "医疗顾问",
      //     typeEn: "ylgw",
      //     title: "咨询",
      //     content:
      //       "您好，我是您的私人医疗顾问，您可以向我咨询任何医疗相关问题。",
      //   },
      //   {
      //     type: "学习顾问",
      //     typeEn: "xxgw",
      //     title: "请教",
      //     content:
      //       "你好，我是您的私人学习顾问，您可以问我关于语文、英语、数学、物理、地理、化学、历史、生物等各学科问题哦",
      //   },
      //   {
      //     type: "法律顾问",
      //     typeEn: "flgw",
      //     title: "咨询",
      //     content: "您好，我是您的法律顾问，我可以帮您解决任何法律问题。",
      //   },
      //   {
      //     type: "私人厨房",
      //     typeEn: "srcf",
      //     title: "制作",
      //     content: "您好，我是您的美食大厨，可以为您提供精致美食菜谱",
      //   },
      //   {
      //     type: "星象占卜",
      //     typeEn: "xxzb",
      //     title: "分析",
      //     content: "您好，我是您的星象占卜师，我可以帮您分析星座运势。",
      //   },
      //   {
      //     type: "旅游出行",
      //     typeEn: "lycx",
      //     title: "制定",
      //     content: "您好，您可以提供游玩地区，我将为您制定最佳游玩路线。",
      //   },
      //   {
      //     type: "语言翻译",
      //     typeEn: "yyfy",
      //     title: "翻译",
      //     content:
      //       "您好，我是您的语言翻译秘书，您可以输入任一种语言的内容并说明翻译成的国家语言，我将为您实时翻译。",
      //   },
      //   {
      //     type: "美食探店",
      //     typeEn: "mstd",
      //     title: "打卡",
      //     content:
      //       "您好，您可以提供想吃的美食或游玩地区，我将为您提供网红特色小吃详细地点和价格。",
      //   },
      //   {
      //     type: "营销策划",
      //     typeEn: "yxch",
      //     title: "策划",
      //     content:
      //       "您好，您可以提出您想要的方案，越详细越好。比如：帮我写一个有创意的艺术培训招生营销方案，且足够吸引学生和家长。",
      //   },
      //   {
      //     type: "AI编程",
      //     typeEn: "AIbc",
      //     title: "编写",
      //     content:
      //       "您好，我是您的IT工程师，您可以提出您的代码要求。比如使用python语句统计成绩，要求输入一批学生成绩。",
      //   },
      // ],
    };
  },
  created() {
    if (navigator.userAgent.includes("AppleWebKit")) {
      this.isIphone = true;
    }
    this.getData()
    // this.getList()
  },
  mounted() {},
  methods: {
    getData () {
      pageCreate().then(res => {
        console.log(res)
        this.createList = res.data
        //this.getList()
      })
    },
    changeOpration (action, index) {
      if (index === 0) {
        this.showNameModal = true
      } else {
        this.$dialog.confirm({
          title: '提示',
          message: '确定删除该创作吗',
        })
          .then(() => {
          })
      }
    },
    getList () {
      queryAllList("conversation").then(res => {
        let dataList = res.data
        console.log(dataList)
        this.dataList = []
        dataList.forEach(item => {
          let results = this.createList.filter(c => c.type === item.type)
          console.log(results)
          if (results.length) {
            item.icon = results[0].picture
          } else {
            item.icon = ''
          }
          this.dataList.push(item)
        });
        console.log(this.dataList)
        this.dataList = this.dataList.filter(item => item.icon !== '')
        this.dataList.sort((a, b)=>{ return b.updateTime-a.updateTime})
      })
    },
    onClickLeft() {
      this.$router.goBack();
    },
    onClickButton() {},
    onSearch(val) {
      console.log(val);
    },
    goChat(type, id) {
      this.$router.push({
        path: "/chat?type=" + encodeURIComponent(type) + '&id=' + id,
      });
    },
    goSubscribe() {
      this.$router.push({
        path: "/subscribe",
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/Mine/mychat1.vue